import { render, staticRenderFns } from "./HeartysanManufacturerListingsBlock.vue?vue&type=template&id=3666abb7&scoped=true"
import script from "./HeartysanManufacturerListingsBlock.vue?vue&type=script&lang=js"
export * from "./HeartysanManufacturerListingsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3666abb7",
  null
  
)

export default component.exports